import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import { Header } from 'dibs-elements/exports/Header.tsx';

type Props = {
    title: ReactNode;
    subtitle?: ReactNode;
};

const NoBarHeader: FC<Props> = ({ title, subtitle }) => (
    <div
        className={classnames(
            dibsCss.pLarge,
            dibsCss.pb0,
            dibsCss.textNoir,
            dibsCss.textCenter,
            dibsCss.mbLarge
        )}
    >
        <Header title={title} subtitle={subtitle} />
    </div>
);

export default NoBarHeader;
